// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-MenuDesk----index-module---wrapper---4FNux","list":"src-components-MenuDesk----index-module---list---1sPJZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuDesk/index.module.css
// module id = 326
// module chunks = 114276838955818